<template>
     <div class="typepartimmobile-registration">
        <b-form  v-show="mode === 'save' || mode === 'remove' || mode === 'read'">
             <input id="typepartimmobile-id" type="hidden" v-model="typepartimmobile.id" />
             <b-row>
                <b-col md="6" sm="12">
                    <b-form-group 
                        label="Property part:" 
                        label-for="typepartimmobile-name_type_part_immobile">
                        <b-form-input 
                            id="typepartimmobile-name_type_part_immobile" 
                            type="text" 
                            ref="searchFocus"
                            v-model="typepartimmobile.name_type_part_immobile" 
                            required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Property part..." />
                    </b-form-group>
                </b-col>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="typepartimmobile.quantitative_control" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="typepartimmobile-quantitative_control"
                                :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="typepartimmobile-quantitative_control">
                                Control Quantity?
                            </label>
                        </div>
                    </div>
                </b-col>  
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="typepartimmobile.blocked" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="typepartimmobile-blocked"
                                :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="typepartimmobile-blocked">
                                Blocked?
                            </label>
                        </div>
                    </div>
                </b-col>  

             </b-row>

         </b-form>
                <b-row>                   
                <b-col xs="12">
                    <b-button  
                        title="Add" 
                        size="sm" 
                        class="mt-2 mb-2 fa fa-plus" 
                        variant="dark" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo"></b-button>
                    <b-button  
                        title="Save"  
                        size="sm" 
                        variant="dark" 
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save"></b-button>
                    <b-button  
                        title="Delete" 
                        size="sm" 
                        variant="dark" 
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove"></b-button>
                    <b-button  
                        title="Back" 
                        size="sm" 
                        variant="dark" 
                        class="mt-2 mb-2 ml-2 fa fa-ban"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset"></b-button>
                    <b-button  
                    size="sm" 
                    title="Search" 
                    class="mt-2 mb-2 ml-2 fa fa-search" 
                    @click="[loadParts(),toggleBusy(),showTable = !showTable]" 
                    variant="dark" 
                    v-show="mode !== 'save' && mode !== 'remove'"
                    >
                    </b-button>
                </b-col>
            </b-row>
            <b-row v-show="mode !== 'save' && mode !== 'remove'">
            <b-col md="6" sm="12">
                <div class="col-sm-6">
                    <b-form-group> 
                    <input size="lg" type="text" icon="search" v-model="search" 
                    placeholder="Search by Property part " class="form-control">                  
                    </b-form-group>
                </div>
            <transition  name="slide" type="animation" appear>       
                <b-table 
                        :busy="isBusy"  
                        class="table-responsive" 
                        hover 
                        key="slide"  
                        head-variant="light" 
                        :per-page="perPage" 
                        :current-page="currentPage" 
                        :items="filteredList" 
                        :fields="fields">
                     <template v-slot:table-busy>
                        <div class="text-center text-info my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>loading...</strong>
                        </div>
                    </template>
                    <template v-slot:cell(actions)="data">
                        <b-button 
                                title="View" 
                                size="sm" 
                                variant="light" 
                                @click="loadPart(data.item, 'read')" 
                                class="mr-2 mt-2">
                            <i class="fa fa-drivers-license-o"></i>
                        </b-button>
                        <b-button 
                            title="Edit" 
                            size="sm" 
                            variant="light" 
                            @click="loadPart(data.item)" class="mr-2 mt-2">
                            <i class="fa fa-pencil"></i>
                        </b-button>
                        <b-button 
                            title="Delete" 
                            size="sm" 
                            variant="light" 
                            @click="loadPart(data.item, 'remove')" 
                            class="mr-2 mt-2">
                            <i class="fa fa-trash"></i>
                        </b-button>
                          <b-button 
                            title="Add sub part" 
                            size="sm" 
                            variant="light" 
                            @click="[setLoadPart(data.item),openModalSub()]" 
                            class="mr-2 mt-2">
                            <i class="fa fa-plus-circle"></i>
                        </b-button>
                         <b-button 
                                title="List sub part" 
                                size="sm" 
                                variant="light" 
                                @click="[setLoadPart(data.item),loadSubParts()]" 
                                class="mr-2 mt-2">
                            <i class="fa fa-list"></i>
                        </b-button>
                    </template>
                </b-table>
            </transition>
            <b-pagination 
              v-model="currentPage" 
              :per-page="perPage"
              :total-rows="rows">
              </b-pagination> 
            </b-col>
                <b-col md="6" sm="12">
                    <transition  name="slide" type="animation" appear>   
                        <b-table 
                        class="table-responsive" 
                        hover 
                        key="slide"  
                        head-variant="light" 
                        :items="typepartimmobilesubs" 
                        :fields="fieldSub">
                          <template v-slot:cell(actions)="data">
                                <b-button 
                                title="Edit" 
                                size="sm" 
                                variant="light" 
                                @click="[setLoadPartSub(data.item),openModalSub()]" class="mr-2 mt-2">
                                <i class="fa fa-pencil"></i>
                                </b-button>
                                <b-button 
                                title="Delete" 
                                size="sm" 
                                variant="light" 
                                @click="showMsgBoxDeleteSub(data.item)" 
                                class="mr-2 mt-2">
                                <i class="fa fa-trash"></i>
                                </b-button>
                            </template>
                        </b-table>
                          
                    </transition>
                </b-col>
            </b-row>
        <b-modal
            id="modalSub"
            ref="modal"
            title-tag="h6"
            title="Sub Part"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveSub"
        >
            <b-form>
                <b-row>
                    <b-col md="12" sm="12">
                        <b-form-group
                            label="Sub Part name:"
                            label-for="typepartimmobilesub-name_type_part_immobile_sub"
                        >
                            <b-form-input
                                id="typepartimmobilesub-name_type_part_immobile_sub"
                                v-model="typepartimmobilesub.name_type_part_immobile_sub"
                                type="text"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
      </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
var moment = require('moment')

export default {
         name: 'TypePartImmobile',
            directives: {moment},
                data: function() {
                return {
                    mode: 'insert',
                    search: '',
                    typepartimmobile: {},
                    typepartimmobilesub: {},
                    typepartimmobiles: [],
                    typepartimmobilesubs: [],
                    showTable: false,
                    showTableSub: false,
                    showSearch: true,
                    isBusy: false,
                    currentPage: 1,
                    perPage: 5,
                    fields: [
                        { key: 'name_type_part_immobile', label: 'Property part', sortable: true },
                        { key: 'quantitative_control', label: 'Quantity Control', sortable: false,
                            formatter: value => value ? 'Yes' : 'No' },
                        { key: 'blocked', label: 'Blocked', sortable: false,
                            formatter: value => value ? 'Yes' : 'No' },
                        { key: 'actions', label: 'Actions', variant: 'secondary' }
                    ],
                    fieldSub:[
                         { key: 'name_type_part_immobile_sub', label: 'Property sub part ', sortable: true },
                        { key: 'actions', label: 'Actions', variant: 'secondary' }
                    ]
                }
            },
            computed: {
                user(){
                    return this.$store.state.user
                },
                compan(){
                    return this.$store.state.compan
                },
                filteredList() {
                return this.typepartimmobiles.filter(typepartimmobile => {
                return typepartimmobile.name_type_part_immobile.toLowerCase().includes(this.search.toLowerCase())
                    })
                },
                icon() {
                    return this.showTable ? "fa-retweet" : "fa-search"
                },
                 rows() {
                    return this.typepartimmobiles.length
                }
            },
            methods: {
            formatDate (date) {
                return moment.utc(date).format('YYYY-MM-DD')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
            loadParts() {
                const url = `${baseApiUrl}/typepartimmobilesbycompany/${this.compan.id}`
                axios.get(url).then(res => {
                    this.typepartimmobiles = res.data
                     this.isBusy = false
            })
            },
            async showMsgBoxDeleteSub(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to delete the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.removeSub(item)
                    }
                })
            },
            loadSubParts() {
                const url = `${baseApiUrl}/typepartimmobilesbytypeparts/${this.typepartimmobile.id}`
                axios.get(url).then(res => {
                    this.typepartimmobilesubs = res.data
            })
            },
            reset() {
                this.mode = 'insert'
                this.loadParts()
            },
            alterModo() {
                        this.mode = 'save'
                        this.typepartimmobile = {}
                        this.$refs.searchFocus.focus();
                },
            save() {
                    this.typepartimmobile = {
                        ...this.typepartimmobile,
                        company_id_type_part_immobile: this.compan.id,
                        user_id_type_part_immobile: this.user.id
                    }
                   
                const method = this.typepartimmobile.id ? 'put' : 'post'
                const id = this.typepartimmobile.id ? `/${this.typepartimmobile.id}` : ''
                axios[method](`${baseApiUrl}/typepartimmobiles${id}`, this.typepartimmobile)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)
            },
            saveSub() {
                    this.typepartimmobilesub = {
                        ...this.typepartimmobilesub,
                        type_part_immobile_id_sub: this.typepartimmobile.id,
                        user_id_type_part_immobile_sub: this.user.id
                    }
                   
                const method = this.typepartimmobilesub.id ? 'put' : 'post'
                const id = this.typepartimmobilesub.id ? `/${this.typepartimmobilesub.id}` : ''
                axios[method](`${baseApiUrl}/typepartimmobilesubs${id}`, this.typepartimmobilesub)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.typepartimmobilesub = {}
                        this.loadSubParts()
                    })
                    .catch(showError)
            },
            remove() {
                const id = this.typepartimmobile.id
                axios.delete(`${baseApiUrl}/typepartimmobiles/${id}`)
                    .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                    })
                    .catch(showError)
            },
            removeSub(item) {
                const id = item.id
                axios.delete(`${baseApiUrl}/typepartimmobilesubs/${id}`)
                    .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.loadSubParts()
                    })
                    .catch(showError)
            },
            loadPart(typepartimmobile, mode = 'save') {
                this.mode = mode
                this.typepartimmobile = { ...typepartimmobile }
                this.$refs.searchFocus.focus();
            },
            setLoadPart(typepartimmobile){
                this.typepartimmobile = { ...typepartimmobile }
            },
            setLoadPartSub(typepartimmobilesub){
                this.typepartimmobilesub = { ...typepartimmobilesub }
            },
            openModalSub() {
                this.$bvModal.show('modalSub')
            },
                
             },
            mounted() {
                this.showTable = true
                this.loadParts()
            }
    }       
</script>

<style>

     .typepartimmobile-registration label {
        font-size: 0.75rem;
        color: black;
    }

    .typepartimmobile-registration select{
        font-size: 0.75rem;
    }
    .typepartimmobile-registration input{
        font-size: 0.75rem;
    }
    .typepartimmobile-registration textarea{
        font-size: 0.75rem;
    }
    .typepartimmobile-registration button{
        font-size: 0.75rem;
    }
    .typepartimmobile-registration table{
        font-size: 0.75rem;
    }

    @keyframes slide-in {
    from {transform: translateY(40px);}
    to {transform: translateY(0);}
    }

    @keyframes slide-out {
        from {transform: translateY(0);}
        to {transform: translateY(40px);}
    }

    .slide-enter-active {
    animation: slide-in 1s ease;
        transition: opacity 1s;
    }

    .slide-leave-active {
        animation: slide-out 1s ease;
        transition: opacity 1s;
    }

    .slide-enter, .slide-leave-to{
        opacity: 0;
    }

    .fade-enter, .fade-leave-to{
    opacity: 0;
    }

    .fade-enter-active, .fade-leave-active{
    transition: opacity 1s;
    }

</style>
